import { render, staticRenderFns } from "./IntOrderPayDetail.vue?vue&type=template&id=3ed16180&scoped=true&"
import script from "./IntOrderPayDetail.vue?vue&type=script&lang=js&"
export * from "./IntOrderPayDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntOrderPayDetail.vue?vue&type=style&index=0&id=3ed16180&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed16180",
  null
  
)

export default component.exports